import DataLoggerRouter from "@/context/data_logger/router/DataLoggerRouter";
import Routes from "@/common/router/Routes";

export default class DataLoggerRoutes extends Routes {
  constructor() {
    super({
      label: "Mikroserwer",
      router: new DataLoggerRouter(),
      lazyPage: () => import("@/context/data_logger/pages/DataLoggerPage.vue"),
      lazyCreate: () => import("@/context/data_logger/containers/DataLoggerFormContainer.vue"),
      lazyUpdate: () => import("@/context/data_logger/containers/DataLoggerFormContainer.vue"),
      lazyList: () => import("@/context/data_logger/containers/DataLoggerListContainer.vue"),
      lazyShow: () => import("@/context/data_logger/containers/DataLoggerShowContainer.vue")
    });
    this.addChild({
      path: "configuration_overview",
      name: "configuration_overview",
      label: "Przegląd konfiguracji",
      visible: true,
      component: () =>
        import("@/context/data_logger/containers/ConfigurationOverviewContainer.vue"),
      url: `${this.router.basePath}/configuration_overview`
    });
    this.addChild({
      path: "create_device_from_configuration",
      name: "create_device_from_configuration",
      label: "Tworzenie urządzenia z konfiguracji",
      visible: true,
      component: () =>
        import("@/context/data_logger/containers/CreateDeviceFromConfiguration.vue"),
      url: `${this.router.basePath}/create_device_from_configuration`
    });
  }
}

export const dataLoggerRoutes = new DataLoggerRoutes();
